import { render, staticRenderFns } from "./court.vue?vue&type=template&id=bc600390&scoped=true&"
import script from "./court.vue?vue&type=script&lang=js&"
export * from "./court.vue?vue&type=script&lang=js&"
import style0 from "./court.vue?vue&type=style&index=0&id=bc600390&prod&scoped=true&lang=css&"
import style1 from "./court.vue?vue&type=style&index=1&id=bc600390&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc600390",
  null
  
)

export default component.exports